<template>
  <div id="app">
    <div v-if="$route.path.includes('sessions') || $route.path.includes('register')" class="bg-auth"></div>

    <div v-if="$root.isLoading" class="loading">
      <div class="loading-box">

        <div class="loading-effect" style="top: 50%;left: 50%;">
          <div class="icon-button ml-1" :style="{ 'background-image': 'url(' + logo + ')' , 'background-size': 'contain',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            height: '3rem',
            width: '3rem'}"
            >
          </div>
        </div>
        <div class="loading-effect">
          <b-spinner style="width: 6rem; height: 6rem; " label="Large Spinner">

          </b-spinner>

        </div>
        <div class="loading-effect mt-3" style="top: 80%;">
          {{ $t('loading...') }}
        </div>
      </div>
    </div>
    <div v-if="$root.transactionIsLoading" class="loading big">
      <div class="loading-box">

        <div class="loading-effect" style="top: 48%;left: 50%;">
          <div class="icon-button" :style="{ 'background-image': 'url(' + logo + ')', 'background-size': 'contain',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            height: '3rem',
            width: '3rem' }">
          </div>
        </div>
        <div class="loading-effect">
          <b-spinner style="width: 7rem; height: 7rem; color: #ff9900;" label="Large Spinner">

          </b-spinner>

        </div>
        <div class="loading-effect mt-2 w-75" style="top: 80%;">
          {{ $t('loading-text') }}
          

        </div>
      </div>
    </div>
    <Header :footer="footer"></Header>
    <div class="app-content" v-if="isAuthShell">
      <div class="max-w-[1640px] w-full mx-auto px-3 px-lg-4 py-4 d-flex flex-column flex-xl-row app-shell-gap">
        <aside class="app-sidebar d-none d-xl-block bg-white rounded-2xl shadow-sm border p-3 text-left">
          <Sidebar :footer="footer"></Sidebar>
        </aside>
        <main class="flex-grow-1 text-left app-main-col">
          <h1 v-if="!hasCustomPageHeader" class="app-page-title">{{ $t(title) }}</h1>
          <router-view></router-view>
        </main>
      </div>
    </div>
    <div class="app-content" v-else>
      <router-view></router-view>
    </div>
    <Footer v-if="!$route.path.includes('login') && !$route.path.includes('register')"></Footer>


    <b-sidebar id="sidebar-right" right shadow backdrop>
      <Sidebar :footer="footer"></Sidebar>
    </b-sidebar>

    <b-modal id="modal-deposit" :title="$t('deposit')" hide-footer><template #modal-title>
        <div class="d-flex justify-content-between w-100">
          <div>
            {{ $t('deposit') }}

          </div>
          <div>
            <span @click="$bvModal.hide('modal-deposit'); $router.push('/web/depositRecord')">
              <i class="fa fa-history"></i>
            </span>

          </div>
        </div>
      </template>
      <Deposit></Deposit>
    </b-modal>
    <b-modal id="modal-withdraw" :title="$t('withdraw')" hide-footer>
      <template #modal-title>
        <div class="d-flex justify-content-between w-100">
          <div>
            {{ $t('withdraw') }}
          </div>
          <div>
            <span @click="$bvModal.hide('modal-withdraw'); $router.push('/web/withdrawRecord')">
              <i class="fa fa-history"></i>
            </span>
          </div>
        </div>
      </template>
      <Withdraw></Withdraw>
    </b-modal>
    <b-modal id="modal-invest" size="lg" :title="$t('invest')" hide-footer>
      <Invest></Invest>
    </b-modal>

    <ModalError></ModalError>
    <ModalNews></ModalNews>

  </div>
</template>

<script>
import Header from './components/header.vue';
import Sidebar from './components/sidebar.vue';
import Footer from './components/footer.vue';
import ModalError from './errorMsg.vue';
import ModalNews from './newsModal.vue';
import Deposit from './views/actions/deposit.vue';
import Withdraw from './views/actions/withdraw.vue';
import Invest from './views/menu/invest.vue';
export default {
  watch: {
    $route() {
      var title = this.$route.path.split('/');
      this.title = title[title.length - 1];
      this.path = this.title;

    },
  },

  
  components: {
    Header,
    Footer,
    ModalError,
    ModalNews,
    Deposit,
    Withdraw,
    Invest,
    Sidebar
  },
  data() {
    return {
      screenWidth: 0,
      path: '',
      username: '',
      address: '',
      title: '',
      logo: require('./assets/images/traders/logo.png'),

     
    }
  },
  methods: {
    breadCrumbs(i) {

      var paths = this.$route.path.split('/');
      if (i == 0)
        return this.$t(paths[paths.length - 2]);
      else
        return this.$t(paths[paths.length - 1]);
    },
    copy(value) {
      navigator.clipboard.writeText(value)
        .then(() => {
          alert(`${this.$t('copySuccess')}: ` + value);
        })
        .catch((error) => {
          alert(error);
        });
    },
    logout() {
      localStorage.removeItem('currencyToken');
      localStorage.removeItem('info');
      this.$router.push('/web/sessions/login');
    },
  },
  computed: {
    computedWidth: function () {
      return this.screenWidth + 'px';
    },
    isAuthShell() {
      return !this.$route.path.includes('sessions') && !this.$route.path.includes('register');
    },
    isDashboardRoute() {
      return this.$route.path.includes('home/dashboard');
    },
    hasCustomPageHeader() {
      // Routes below render their own richer header (breadcrumb, bilingual
      // title, description) instead of the generic one, so it must not be
      // duplicated here.
      return this.isDashboardRoute || this.$route.path.includes('accounts/create_trading_account');
    },
    footer() {
      // const isMaster = Number(this.$root.userInfo?.pamm_master) === 1 || Number(this.$root.userInfo?.mamm_master) === 1 ;
      // const isPammMaster = Number(this.$root.userInfo?.pamm_master) === 1;
      // const isMammMaster = Number(this.$root.userInfo?.mamm_master) === 1;

      
      return [
        { name: 'dashboard', path: '/web/home/dashboard' },
        {
          name: 'accounts',
          path: '/web/accounts/create_trading_account',
          children: [
            { name: 'create_trading_account', path: '/web/accounts/create_trading_account' },
            { name: 'trading_accounts', path: '/web/accounts/trading_accounts' },
            // { name: 'pamm_accounts', path: '/web/accounts/pamm_accounts' },
            // { name: 'mamm_accounts', path: '/web/accounts/mamm_accounts' },
          ]
        },
        {
          name: 'profile',
          path: '/web/profile',
          // children: [
          //   { name: "main", path: '/web/profile/main' },
          //   { name: "kyc", path: '/web/profile/kyc' },
          //   { name: "bank-information", path: "/web/profile/bank-information" },
          //   { name: "security", path: '/web/profile/security' },
          // ]
        },
        // {
        //   name: 'traders',
        //   path: '/web/traders/pammList',
        //   children: [
        //     // { name: 'fund_management', path: '/web/traders/fund_management' },
        //     { name: 'pammList', path: '/web/traders/pammList' },
        //     { name: 'mammList', path: '/web/traders/mammList' },
        //     ...(isMaster ? [
        //       { name: 'slaveWithdrawReq', path: '/web/traders/slaveWithdrawReq' },
        //       { name: 'slaveDepositReq', path: '/web/traders/slaveDepositReq' },
        //     ] : []),
        //     ...(isPammMaster ? [
        //       { name: 'pammSlave', path: '/web/traders/pammSlave' },
        //     ] : []),
        //     ...(isMammMaster ? [
        //       { name: 'mammSlave', path: '/web/traders/mammSlave' },
        //     ] : [])
        //   ]
        // },
        // {
        //   name: 'actions',
        //   path: '/web/actions/',
        //   children: [
        //     { name: 'convert', path: '/web/actions/convert' },
        //     // { name: 'transferToMT5Record', path: '/web/actions/transferToMT5Record' },
        //     // { name: 'withdrawFromEwalletRecord', path: '/web/actions/withdrawFromEwalletRecord' },
        //     {
        //       name: 'USDT',
        //       path: '/web/actions/usdt',
        //       // children: [
        //       //   { name: 'deposit', path: '/web/actions/deposit' },
        //       //   { name: 'depositRecord', path: '/web/actions/depositRecord' },
        //       //   { name: 'cashWalletWithdraw', path: '/web/actions/cashWalletWithdraw' },
        //       //   { name: 'walletWithdrawRecord', path: '/web/actions/walletWithdrawRecord' },
        //       // ]
        //     },
        //     {         
        //       name: 'FIAT',
        //       path: '/web/actions/fiat',
        //       // children: [
        //       //   { name: 'depositFiat', path: '/web/actions/depositFiat' },
        //       //   { name: 'depositFiatRecord', path: '/web/actions/depositFiatRecord' },
        //       //   { name: 'withdrawFiat', path: '/web/actions/withdrawFiat' },
        //       //   { name: 'withdrawFiatRecord', path: '/web/actions/withdrawFiatRecord' },
        //       // ]
        //     },
        //   ]
        // },
        {
          name: 'network',
          path: '/web/network/ib_network',
          children: [
            { name: 'ib_network', path: '/web/network/ib_network' },
          ]
        },
        {
          name: 'report',
          path: '/web/report/wallet_transaction',
          children: [
            { name: 'transaction', path: '/web/report/transaction' },
            { name: 'ranking_bonus', path: '/web/report/ranking_bonus' },
          ]
        },
      ];
    }
  },
  created() {
    this.screenWidth = screen.width;

  },
  mounted() {
    var title = this.$route.path.split('/');
    this.title = title[title.length - 1];
    this.path = this.title;

    var info = JSON.parse(localStorage.getItem('info'));
    if (info)
      this.$root.username = info.username;

    this.$root.getCountryList();
    // this.$root.getCountryDepositList();
    var token = localStorage.getItem('currencyToken');
    if (token) {
      this.$root.getInfo();
      this.$root.getTicket(1);
      this.$root.getNewsList();
      this.$root.getMt5Accounts();
    }
  }
}
</script>

<style>
#app {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "PingFang SC", "Microsoft YaHei", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
  position: relative;

}
.bg-auth {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('./assets/images/bg/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
}
</style>
